import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';

import { openWindow } from 'store/actions/windows';
import { getNodeTitle } from 'services/getNodeTitle';
import { HealthIcon, CaretIcon } from './icons';
import { isOffline, isErrored, isKnownStatus } from './equipment-status';
import { Widget, WHead, WIco, WTitle, Chip, Caret, WBody, Stats, Stat, Row, Dot, RackName, Status, Empty } from './widgets-dock.styled';

const EQUIP_TYPES = ['single_rack', 'double_rack', 'payment_terminal', 'cashbox', 'goose'];

export const HealthWidget = ({ open, onToggle }) => {
  const { t } = useTranslation();
  const equipment = useSelector((store) => store.equipment, shallowEqual);
  const events = useSelector((store) => store.events.events, shallowEqual);
  const dispatch = useDispatch();

  const nodes = window.config.nodes || {};

  const offline = [];
  const errored = [];
  let online = 0;
  let total = 0;

  Object.keys(nodes).forEach((id) => {
    const node = nodes[id];
    if (!node || EQUIP_TYPES.indexOf(node.type) === -1) {
      return;
    }
    total += 1;
    const eq = equipment ? equipment[id] : null;
    const nodeEvents = events ? events[id] : null;
    // Недоступность ловим по mode === 'offline' И по сенсору controller.is_online.
    // «Нет данных» (статус ещё не пришёл) НЕ считаем офлайном — устройство просто
    // не попадёт ни в один из счётчиков, пока не придёт статус.
    if (isOffline(eq)) {
      offline.push(node);
    } else if (isErrored(eq, nodeEvents)) {
      errored.push(node);
    } else if (isKnownStatus(eq)) {
      online += 1;
    }
  });

  const openRack = (node) => {
    if (!node) {
      return;
    }
    dispatch(
      openWindow({
        id: node.id,
        type: 'rack',
        data: { id: node.id, type: node.type, barriersCount: node.barriersCount, withSignals: true },
        header: getNodeTitle(node.type, node.id, node.caption),
      })
    );
  };

  const problems = [...errored, ...offline];

  return (
    <Widget>
      <WHead type="button" className={open ? '' : 'closed'} onClick={onToggle}>
        <WIco>
          <HealthIcon />
        </WIco>
        <WTitle>{t('dock.Здоровье оборудования')}</WTitle>
        {problems.length > 0 ? <Chip className={errored.length ? 'red' : 'ghost'}>{problems.length}</Chip> : <Chip className="ghost">{total}</Chip>}
        <Caret className={open ? 'open' : ''}>
          <CaretIcon />
        </Caret>
      </WHead>
      {open && (
        <WBody>
          <Stats>
            <Stat className="ok">
              <b>{online}</b>
              <span>{t('dock.онлайн')}</span>
            </Stat>
            <Stat className="offline" /* $clickable={offline.length > 0} onClick={() => openRack(offline[0])}*/>
              <b>{offline.length}</b>
              <span>{t('dock.офлайн')}</span>
            </Stat>
            <Stat className="crit" /* $clickable={errored.length > 0} onClick={() => openRack(errored[0])}*/>
              <b>{errored.length}</b>
              <span>{t('dock.ошибка')}</span>
            </Stat>
          </Stats>
          {problems.slice(0, 20).map((node) => {
            // console.log("node", node);
            const off = offline.indexOf(node) !== -1;
            const title = getNodeTitle(node.type, node.id, node.caption);
            return (
              <Row key={node.id} as="button" style={{ cursor: 'pointer', width: '100%' }} onClick={() => openRack(node)}>
                <Dot className={off ? 'gray' : 'red'} />
                <RackName title={title}>{title}</RackName>
                <Status>{off ? t('dock.нет связи') : t('dock.ошибка оборудования')}</Status>
              </Row>
            );
          })}
          {total > 0 && problems.length === 0 && <Empty>{t('dock.Всё оборудование в работе')}</Empty>}
          {total === 0 && <Empty>{t('dock.Нет данных об оборудовании')}</Empty>}
        </WBody>
      )}
    </Widget>
  );
};
